var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8482 14.5741H20.5625M14.8482 22.5026H20.5625M6.00894 22.3732L7.92411 24.2884L11.1161 19.8196M6.00894 14.3018L7.92411 16.2169L11.1161 11.7482M26.143 28.5741C26.143 29.1802 25.9021 29.7617 25.4735 30.1903C25.0447 30.6189 24.4634 30.8598 23.8573 30.8598H3.28571C2.6795 30.8598 2.09813 30.6189 1.66946 30.1903C1.24082 29.7617 1 29.1802 1 28.5741V3.43122C1 2.825 1.24082 2.24363 1.66946 1.81498C2.09813 1.38632 2.6795 1.14551 3.28571 1.14551H16.0532C16.6594 1.14551 17.2408 1.38632 17.6695 1.81498L25.4735 9.6189C25.9021 10.0475 26.143 10.6289 26.143 11.2351V28.5741Z",
    stroke: "#AA1A5F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation6);
export default __webpack_public_path__ + "static/media/location6.162a88b7a469241c8be5b23d0e05c4ee.svg";
export { ForwardRef as ReactComponent };